import React from 'react';
import { SummaryCharts } from './SummaryStyles';
import { SummaryChart } from './SummaryChart/SummaryChart';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';
import { useIsEmbeddedMobile } from '../../_hooks/useIsEmbeddedMobile';
import { SimpleTab } from '../../CommonComponents/OPL/Tab/SimpleTab';
import { Box } from '../../CommonComponents/OPL/Box/Box';

export const SummaryLoading = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <>
      {isEmbeddedMobile ? (
        <>
          <Box display="flex" mx="12" mt="24">
            <SimpleTab isActive style={{ width: '50%' }}>
              Current Scenario
            </SimpleTab>
            <SimpleTab isActive={false} color="neutral.500" style={{ width: '50%' }}>
              Recommended
            </SimpleTab>
          </Box>
          <SummaryCharts>
            <SummaryChart isLoading />
          </SummaryCharts>
        </>
      ) : (
        <SummaryCharts>
          <SummaryChart title="Current Scenario" isLoading />
          <SummaryChart title="Recommended Scenario" isLoading />
        </SummaryCharts>
      )}
      <Shimmer width="100%" height="600px" />
    </>
  );
};
